var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGetMicrosoftAppButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.556 7H7v8.56h8.556V7z",
    fill: "#F25022"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 7h-8.556v8.56H25V7z",
    fill: "#7FBA00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.556 16.44H7V25h8.556v-8.56z",
    fill: "#00A4EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 16.44h-8.556V25H25v-8.56z",
    fill: "#FFB900"
  })));
}
export default SvgGetMicrosoftAppButton;